import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Checkbox } from "antd";
import { BrowserRouter as Router, Link } from "react-router-dom";
const { Title, Paragraph } = Typography;

const ChargebackStats = (props) => {
  const { t, data,  showAll } = props;
  const [hideWidget, setHideWidget] = useState([]);

  useEffect(() => {
    if (showAll) {
         return setHideWidget([])
    }

  }, [showAll]); // eslint-disable-line react-hooks/exhaustive-deps

  const analytics = [
    {
      title: "Visa",
      desc: t("contents.dashboard.chargebackCount"),
    },
    {
      title: "MasterCard",
      desc: t("contents.dashboard.chargebackCount"),
    },
    {
      title: "American Express",
      desc: t("contents.dashboard.chargebackCount"),
    },

    {
      title: "Discover",
      desc: t("contents.dashboard.chargebackCount"),
    },
  ];

  const onCheckbox = (i) => {
    setHideWidget((hv) => ([...hv, i]));
    props.setCheckShowAllChargebackWidget(false)
   
  };

  const loadWidget = () => {
    return analytics.map((analytic, index) => {
      const cardBrand = analytic.title.toLowerCase();
      const cardBrandField = cardBrand === "american express" ? "amex" : cardBrand
      if (!hideWidget.includes(index) || showAll) {
        return (
          <Col key={index} flex="auto">
            <Card
              size="small"
              style={{ marginBottom: "0.75rem", cursor: "pointer" }}
            >
              <Row justify="space-between">
                <Col>
                  <Title style={{ minWidth: "80px" }} level={5}>
                    {analytic.title}
                  </Title>
                </Col>
                <Col>
                  <Checkbox onChange={() => onCheckbox(index)}>Hide</Checkbox>
                </Col>
              </Row>
              {/* <Row justify="space-between">
                <Col>
                  <Badge
                    count={t("contents.dashboard.today")}
                    style={{ backgroundColor: "#108ee9" }}
                  />
                </Col>
              </Row> */}
              <Link
                to={{
                  pathname: `/chargebacks?card=${analytic.title.replace(
                    /\s/g,
                    ""
                  )}`,
                }}
              >
                <Row justify="space-between" align="middle">
                  <Col flex="auto">
                    <span
                      style={{
                        display: "block",
                        fontSize: "1.75rem",
                        fontWeight: "300",
                        color: "black",
                      }}
                    >
                  {data?.chargeback_stats[cardBrandField] ?? 0}
                    </span>
                  </Col>
                </Row>
              </Link>
              <Paragraph style={{ fontSize: "0.8rem", marginBottom: "0.5em" }}>
                {analytic.desc}
              </Paragraph>
            </Card>
          </Col>
        );
      }

      return null;
    });
  };

  return (
    <Router forceRefresh={true}>
      <Row gutter={[16, 16]}>{loadWidget()}</Row>
    </Router>
  );
};

export default ChargebackStats;
